import React from 'react'
import { Options } from '../start-recording.page';
import FileModal from './file-modal.component';
import BotConnectModal from './bot-connect-modal.component';

interface IProps {
  type: Options;
  setSelectedOption: (option: Options | null) => void;
}

const Modals = ({ type, setSelectedOption }: IProps) => {

  if (type === 'file') {
    return <FileModal show={type === 'file'} setSelectedOption={setSelectedOption} />
  } else {
    if (!type) return null;
    return <BotConnectModal show={!!type} setSelectedOption={setSelectedOption} type={type} />
  }
}

export default Modals